/**
 * Atualiza href, data-translate e rótulo do link quando o Weglot muda o idioma sem reload.
 */
function bdParseWeglotAlternatives(root) {
    const raw = root.getAttribute('data-bd-weglot-alternatives');
    if (!raw) {
        return [];
    }
    try {
        return JSON.parse(raw);
    } catch {
        return [];
    }
}

function bdPickOppositeLanguage(alternatives, currentLang) {
    if (!alternatives.length || !currentLang) {
        return null;
    }
    return alternatives.find((e) => e.code !== currentLang) || null;
}

function bdUpdateWeglotLangLink(root, currentLang) {
    const el = root.querySelector('[data-bd-weglot-lang-link]');
    if (!el) {
        return;
    }
    const target = bdPickOppositeLanguage(bdParseWeglotAlternatives(root), currentLang);
    if (!target) {
        return;
    }
    if (target.url) {
        el.setAttribute('href', target.url);
    }
    el.setAttribute('data-translate', target.code);
    el.textContent = target.label;
    if (target.aria_label) {
        el.setAttribute('aria-label', target.aria_label);
    }
    if (target.code) {
        el.setAttribute('hreflang', target.code);
    }
}

function bdInitWeglotLanguageSwitcher() {
    const roots = document.querySelectorAll('[data-bd-weglot-switcher]');
    if (!roots.length) {
        return;
    }

    const refreshAll = (lang) => {
        roots.forEach((r) => bdUpdateWeglotLangLink(r, lang));
    };

    const bind = () => {
        if (typeof window.Weglot === 'undefined') {
            return false;
        }
        const cur =
            typeof window.Weglot.getCurrentLang === 'function' ? window.Weglot.getCurrentLang() : null;
        if (cur) {
            refreshAll(cur);
        }
        if (typeof window.Weglot.on === 'function') {
            window.Weglot.on('languageChanged', (newLang) => {
                refreshAll(newLang);
            });
        }
        return true;
    };

    if (bind()) {
        return;
    }

    let tries = 0;
    const id = window.setInterval(() => {
        tries += 1;
        if (bind() || tries > 120) {
            window.clearInterval(id);
        }
    }, 50);
}

document.addEventListener('DOMContentLoaded', bdInitWeglotLanguageSwitcher);
